import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validateFormat } from 'ember-changeset-validations/validators';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';

const forgotPasswordValidation = {
  email: validateFormat({
    type: 'email',
    message: 'Not a valid email address',
  }),
};

export default class ResetPasswordIndexRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  queryParams = {
    email: {
      replace: true,
    },
  };

  model(params: { email?: string }) {
    this.navbarSettings.title = 'Reset Password';
    let record = this.store.createRecord('reset-password', {
      email: params.email,
    });

    return {
      record: record,
      changeset: Changeset(
        record,
        lookupValidator(forgotPasswordValidation),
        forgotPasswordValidation,
      ),
    };
  }
}
